var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameras({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 17.9314C31 17.3256 31 17.0226 30.8802 16.8824C30.7763 16.7607 30.6203 16.6961 30.4608 16.7086C30.2769 16.7231 30.0627 16.9373 29.6343 17.3657L26 21L29.6343 24.6343C30.0627 25.0627 30.2769 25.2769 30.4608 25.2914C30.6203 25.3039 30.7763 25.2393 30.8802 25.1176C31 24.9774 31 24.6744 31 24.0686V17.9314Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.8C11 17.1198 11 16.2798 11.327 15.638C11.6146 15.0735 12.0735 14.6146 12.638 14.327C13.2798 14 14.1198 14 15.8 14H21.2C22.8802 14 23.7202 14 24.362 14.327C24.9265 14.6146 25.3854 15.0735 25.673 15.638C26 16.2798 26 17.1198 26 18.8V23.2C26 24.8802 26 25.7202 25.673 26.362C25.3854 26.9265 24.9265 27.3854 24.362 27.673C23.7202 28 22.8802 28 21.2 28H15.8C14.1198 28 13.2798 28 12.638 27.673C12.0735 27.3854 11.6146 26.9265 11.327 26.362C11 25.7202 11 24.8802 11 23.2V18.8Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameras);
export default __webpack_public_path__ + "static/media/cameras.2ff6a3d81545fcade2f11a339e0c6c9a.svg";
export { ForwardRef as ReactComponent };